import React, { useState, useEffect } from 'react'
import MuiAlert from '@material-ui/lab/Alert'
import { Icon, IconButton, makeStyles, Snackbar } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	snackbar: {
		zIndex: 10001
	},
	alert: {
		display: 'flex',
		alignItems: 'center',
		background: '#3B0275',
		borderRadius: 6,
		fontFamily: 'Nunito',
		fontSize: '16px',
		lineHeight: '26px',
		paddingTop: 4,
		paddingBottom: 4,
		color: '#FFFFFF',
		'& .MuiAlert-message': {
			paddingTop: 0,
			paddingBottom: 0,
			color: '#FFFFFF'
		},
		'& .MuiAlert-icon': {
			padding: 0
		}
	},
	icon: {
		fontSize: '16px'
	},
	statusIcon: {
		fontSize: '16px',
		lineHeight: '19px',
		height: '18px'
	}
}))

const Alert = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [isOpen, setOpen] = useState(false)

	let { anchorOrigin, severity, message } = props
	let autoHideDuration = 5000

	useEffect(() => {
		if (anchorOrigin && severity && message) {
			setOpen(true)
		} else {
			setOpen(false)
		}
	}, [anchorOrigin, severity, message])

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return
		}

		setOpen(false)

		setTimeout(() => {
			dispatch({ type: 'CLEAR_ALERT' })
		}, 500)
	}

	return (
		<Snackbar
			open={isOpen}
			classes={{
				root: classes.snackbar
			}}
			autoHideDuration={autoHideDuration}
			anchorOrigin={anchorOrigin}
			onClose={handleClose}>
			<MuiAlert
				elevation={6}
				variant="filled"
				severity={severity}
				className={classes.alert}
				icon={
					<Icon
						style={{ color: severity === 'success' ? '#4CAF50' : '#D02C2C' }}
						className={clsx([
							`${severity === 'success' ? 'fas fa-check-circle' : 'fas fa-times-circle'}`,
							classes.statusIcon
						])}
					/>
				}
				action={
					<IconButton aria-label="close" color="inherit" onClick={handleClose}>
						<Icon className={clsx(['fas fa-times', classes.icon])} />
					</IconButton>
				}
				paper>
				{message}
			</MuiAlert>
		</Snackbar>
	)
}

export default Alert
